import React from 'react'
import kenettoLogo from '../../../resources/images/logoKenetto-01.svg'

import './style.css'

export default class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props)
    this.state = { hasError: false, error: undefined }
  }

  componentDidCatch (error, info) {
    // Display fallback UI
    this.setState({ hasError: true, error: error })
    // You can also log the error to an error reporting service
    console.log(error)
    console.log(info)
  }

  render () {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div className='error-page'>
        <div className='center-vertically'>
          <img src={kenettoLogo} alt='Kenetto Logo' />
          <h1>Something went wrong.
            <br /><small>We are working on fixing the problem.</small>
            <br /><small className='smaller'>If the problem persists please contact <a href='mailto: contactus@kenetto.com'>contactus@kenetto.com</a></small>
          </h1>
          {/* <h6>{this.state.error.toString()}</h6> */}
        </div>
      </div>
    }
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/components/common/ErrorBoundary/ErrorBoundary.js